export function filterConnectionTree(items, query, setExpandedItems, includeChildren = false) {
    if (!query) {
        setExpandedItems([]);
        return items;
    }
    const lowerQuery = query.toLowerCase();
    return items.map((item)=>{
        const hasMatches = item.title.toLowerCase().includes(lowerQuery);
        if (hasMatches) {
            setExpandedItems((prev)=>[
                    ...prev,
                    item.itemId
                ]);
            // If parent matches and includeChildren is true, include all children unfiltered
            if (includeChildren) {
                return {
                    ...item,
                    children: item.children || []
                };
            }
            // If not including children, filter children as normal
            const children = item.children ? filterConnectionTree(item.children, query, setExpandedItems, includeChildren) : [];
            return {
                ...item,
                children
            };
        }
        // Recursively filter children
        const children = item.children ? filterConnectionTree(item.children, query, setExpandedItems, includeChildren) : [];
        if (children && children.length > 0) {
            setExpandedItems((prev)=>[
                    ...prev,
                    item.itemId
                ]);
            return {
                ...item,
                children
            };
        }
        setExpandedItems((prev)=>prev.filter((id)=>id !== item.itemId));
        return false;
    }).filter((x)=>!!x);
}
